import React from "react";
import { createStore, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { Footer, reducer } from 'viihdeonline-shared-components';
import { user } from 'login';

import $ from "jquery";
import c from '../../common';
import scroll from "../../scroll";

// Temporary imports for footerVisibleHeight()
// Used in components/sidebar.js

export function footerGetVisibleHeight()
{
  let $footer = $('#viihde-footer');
  let height = Math.max(0, $(window).height() + scroll.top() - $footer.offset().top - c.asInt($footer.css("margin-top")));
  return height;
}

class ViihdeFooter extends React.Component {
  render() {
    const { translations } = window;
    const  store = createStore(combineReducers({ ReactHeaderReducer: reducer }));
    let locale;
    user.onValue(user => locale = user.locale || 'fi');
      return (
        <Provider store={store}>
          <div id="viihde-footer">
              <IntlProvider defaultLocale="fi" locale={locale} messages={translations} textComponent="span">
                  <Footer />
              </IntlProvider>
          </div>
        </Provider>
    );
  }
}

export default ViihdeFooter;



// WEBPACK FOOTER //
// ./web/js/components/footer/ViihdeFooter.js